<template>
    <div>
        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
            <div class="input-group" dir="ltr">
                <input
                    type="text"
                    class="form-control"
                    :dir="dirInput"
                    v-model="searchCriteriaLocal"
                    @input="onSearchInput"
                    @focus="onFocusInput"
                    @keyup.enter="Search">

                <div class="input-group-append">
                    <MdButton
                        v-bind:Name="'btnsearchinput'"
                        v-bind:VariantProp="'btn btn-sm search-attached SearchBlue'"
                        v-bind:IconClass="'mdi mdi-magnify'"
                        v-on:click="Search">
                    </MdButton>
                </div>
            </div>
            <div v-if="showDropdownLocal" class="autocomplete-results">
                <div v-for="item in this.DataList" :key="item.code" class="autocomplete-item" @click="selectItem(item)">
                    {{ item.name }}
                </div>

                <div v-if="DataList.length > 0 && IsVisibleMoreResult" class="see-more-item" @click="seeMoreResults">
                    See More Results
                </div>

                <div v-if="this.DataList.length === 0 && searched" class="autocomplete-item">
                    {{$t('MdTable.nRecShow')}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'MdEditSearch',

  props:{
    DataList:Array,
    Id:String,
    SearchCriteria:String,
    SearchHandler:Function,
    showDropdown:Boolean,
    IsVisibleMoreResult:{ type: Boolean, default: true },
    ItemHandler:Function
  },

  data(){
    return{
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        timeoutId: null,
        searched: false,
        selectedCode: null
    }
  },

  computed: {
        searchCriteriaLocal: {
            get() {
                return this.SearchCriteria;
            },
            set(value) {
                this.$emit('update:SearchCriteria', value);
            }
        },
        showResults() {
            return this.searchCriteriaLocal.trim().length > 0;
        },
        showDropdownLocal: {
            get() {
                return this.showDropdown;
            },
            set(value) {
                this.$emit('update:showDropdown', value);
            }
    }
    },

  methods:{

    onFocusInput() {
        if (this.DataList && this.DataList.length > 0) {
            this.showDropdownLocal = true;
        }
    },

    seeMoreResults(){
        this.$emit('see-more-results');
    },

    selectItem(item) {
        this.searchCriteriaLocal = item.name;
        this.selectedCode = item.code;
        this.showDropdownLocal = false;
        this.ItemHandler(item);
    },

    handleOutsideClick(event) {
        if (!this.$el.contains(event.target)) {
            this.showDropdownLocal = false;
        }
    },

    Search(){
         clearTimeout(this.timeoutId);
        this.SearchHandler();
    },

    onInput(value){
        this.$emit('input', value)
    },

    onSearchInput() {

        clearTimeout(this.timeoutId);
        if(this.searchCriteriaLocal?.trim().length < 3) {
            this.showDropdownLocal = false;
            return;
        }

        this.timeoutId = setTimeout(() => {
            this.Search();
        }, 1500);
    }


  },

  mounted(){
     document.addEventListener('click', this.handleOutsideClick);
  },

  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
},

};
</script>


<style scoped>

.autocomplete-results {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    background: #ffffff;
    border: 1px solid #d8e7ef;
    border-radius: 4px;
    box-shadow: 0 3px 12px rgba(0,0,0,.15);
    z-index: 9999;
    max-height: 300px;
    overflow-y: auto;
    margin-top: 2px;
}

.autocomplete-item {
    padding: 10px 14px;
    font-size: 15px;
    color: #4b4b63;
    cursor: pointer;
    transition: all .15s ease;
    border-bottom: 1px solid #f3f5f7;
}

.autocomplete-item:last-child {
    border-bottom: none;
}

.autocomplete-item:hover {
    background: #e8f8fd;
    color: #00a6d6;
    padding-left: 18px;
}

.autocomplete-item:hover {
    background: linear-gradient(
        to right,
        #e6f8ff,
        #f7fcff
    );
    color: #0098c8;
}

.autocomplete-item.selected {
    background: #00a6d6;
    color: white;
}
.autocomplete-results {
   /* max-height: 180px;*/
    overflow-y: auto;
}

.see-more-item {
    padding: 12px;
    text-align: center;
    font-weight: 600;
    color: white;
    background: #00a6d6;
    cursor: pointer;
    border-top: 1px solid #d8e7ef;
}

.see-more-item:hover {
    background: #008fba;
}

.SearchBlue{
  font-weight: bolder !important;
  border-color: #19BEE8!important;
  text-shadow: 1px 1px 1px #FFF, -1px -1px 1px #FFF, 1px -1px 1px #FFF, -1px 1px 1px #FFF!important;
  background-color: #19BEE8!important;
  padding: 0 10px!important;
  outline: 0!important;
}

</style>

